exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".account_box[data-v-65d939f1]{padding:20px 20px 40px 20px}.title[data-v-65d939f1]{font-size:20px;font-weight:600}.search_criteria[data-v-65d939f1]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-top:10px}.search_criteria>div[data-v-65d939f1]{margin:0 5px;width:180px}.w100[data-v-65d939f1]{width:100%}", ""]);

// exports
